<template>
    <div class="lesson-box">
        <div
                @click="goDetail(item.url,item.classId)"
                v-for="(item, index) in goodList"
                :key="index"
        >
            <el-row class="el-row-out" style="background-color: white">
                <el-col :span="6">
                    <div>
                        <el-image class="lesson-img"
                                  :src="'data:image/'+item.imgType+';base64,'+item.picSub">
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image>
                    </div>
                </el-col>
                <el-col :span="18">
                    <el-row :gutter="8" class="el-row-in">
                        <el-col :span="24">
                            <div class="lesson-text-line1">{{ item.classTitle }}</div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                        <el-col :span="12">
                            <el-tag type="danger" size="small" class="lesson-tag">{{
                                item.classType
                                }}
                            </el-tag>
                        </el-col>
                        <el-col :span="10">
                            <i class="el-icon-date" style="font-size:10px;margin-top: 2vh">{{item.publishDate|formatDateDay}}</i>
                        </el-col>
                        <!--            <el-col :span="7">-->
                        <!--              <i class="el-icon-user" style="font-size:8px">{{ item.count }}</i>-->
                        <!--            </el-col>-->
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div>
            <el-row class="period-back-img">
                <div class="wj-row-title">往季合辑</div>
            </el-row>
            <OldPeriodClassList></OldPeriodClassList>
        </div>
        <el-row class="last-class-img"></el-row>
        <!--        <el-image :src="url"></el-image>-->
        <!--        <div class="last-img"></div>-->
    </div>

</template>
<script>
    import {queryOldPeriodList} from "@api/lesson";
    import {formatDate} from "@api/date.js";
    import {submitLession} from "@api/lesson";
    import OldPeriodClassList from "@components/OldPeriodClassList";
    export default {
        name: "OldClassChannelList",
        components: {OldPeriodClassList},
        props: {
            goodList: {
                type: Array,
                default: () => []
            },
            isSort: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                url: '@assets/images/classChannel/3.jpg',
                info: {oldPeriodList: []}
            };
        },
        mounted(){
            this.getOldPeriodList()
            /**
             * iframe-宽高自适应显示
             */
            function changeMapIframe(){
                const map = document.getElementById('map');
                const deviceWidth = document.body.clientWidth;
                const deviceHeight = document.body.clientHeight;
                map.style.width = Number(deviceWidth) + 'px'; //数字是页面布局宽度差值
                map.style.height = Number(deviceHeight)+ 'px'; //数字是页面布局高度差
            }

            changeMapIframe()
            window.onresize = function(){
                changeMapIframe()
            }
        },
        methods: {
            // 商品详情跳转
            goDetail(url, id) {
                console.log("url:" + url);
                var params = {
                    classId: id,
                    url:url
                }
                submitLession(params).then(response => {
                    console.log(response.rsp)
                    if(url!==""){
                        if (response.rsp === "false") {
                            this.$message.warning('请刷新页面并完成团组织绑定！');
                        } else {
                            window.location.href = url
                        }

                    }else{
                        this.$message.warning('新的一期课程发布中,请等待！');
                        console.log(console.log(url))
                    }
                    // window.open(url, "_self","toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=no, resizable=no, copyhistory=yes, width=400, height=400");
                });
                // window.open(url, "_self");
            },
            getOldPeriodList() {
                var params = {
                    state: 1
                };
                queryOldPeriodList(params).then(res => {
                    console.log(res.oldPeriodList);
                    this.info.oldPeriodList = res.oldPeriodList;
                })
            }
        },
        filters: {
            formatDateDay(time) {
                var date = new Date(time);
                return formatDate(date, "yyyy-MM-dd");
            }
        }
    };
</script>

<style>
    .lesson-text-line1 {
        text-align: left;
        margin-top: 1vh;
        font-size: 12px;
        margin-left: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .lesson-box {
        /*margin-left: 0vw;*/
        /*margin-right: 0vw;*/
        /*margin-top: 1vh;*/
        /*padding: 1px;*/
        margin: 0px;
    }

    .lesson-img {
        margin-top: 1vh;
        margin-left: 1px;
        width: 100%;
        border-radius: 5px;
    }

    .el-row-out {
        /*height: 16.5vh;*/
        margin: 1vh;
        /*border:2px solid white;*/
        border-radius: 8px;
        padding: 1vw;
    }

    .el-row-in {
        margin-bottom: 5vh;
    }

    .lesson-tag {
        margin-left: 1vw;
        width: 90%;
        border-radius: 30px;
    }

    .last-class-img {
        height: 20vh;
        width: 100%;
        position: relative;
        text-align: center;
        background-size: 100% 100%; /*按比例缩放*/
        background-image: url("../assets/images/classChannel/3.jpg");
    }
    .period-back-img {
        height: 10vh;
        width: 100%;
        position: relative;
        text-align: center;
        background-size: 100% 100%; /*按比例缩放*/
        background-image: url("../assets/images/classChannel/wjtitle.jpg");
    }
    .wj-row-title {
        /*height: 16.5vh;*/
        font-size: 25px !important;
        letter-spacing: 6px;
        font-weight: bold;
        color: gold;
        margin: 2vh;
        border-radius: 8px;
        position: relative;
        text-align: center;
        /*padding: 1vw;*/
    }

</style>
